<template>
  <b-container>
    <div>
      <h2>{{ $t("story.title") }}</h2>
    </div>
    <div>
      <b-table
        ref="table"
        :busy="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>{{ $t("geral.loadingData") }}</strong>
          </div>
        </template>
      </b-table>
    </div>
    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
    <!-- <div>cargoExpenseId: {{ cargoExpenseId }}</div> -->
    <!-- <div>{{ model }}</div> -->
    <!-- <div>model.weight: {{model.weight}}</div> -->
  </b-container>
</template>
<script>
import TablePaginationProps from "@/components_rms/base/TablePaginationProps.vue";

export default {
  name: "CargoStory",
  directives: {},
  components: {
    TablePaginationProps,
  },
  props: {
    cargoId: Number,
  },
  data() {
    return {
      isBusy: false,
      fields: [
        {
          key: "changedColumn",
          filterKey: "changedColumn",
          label: this.$t("story.changedColumn"),
        },
        {
          key: "oldValue",
          filterKey: "oldValue",
          label: this.$t("story.oldValue"),
        },
        {
          key: "newValue",
          filterKey: "newValue",
          label: this.$t("story.newValue"),
        },
        {
          key: "date",
          filterKey: "date",
          label: this.$t("story.date"),
          //   tdClass: "table-col-dinamic-width",
          thStyle: "min-width: 160px",
          formatter: (value, key, item) => {
            let date = new Date(value);
            let dateString = date.toLocaleDateString();
            let timeString = date.toLocaleTimeString();
            let dateTimeString = `${dateString} ${timeString}`;
            return dateTimeString;
          },
        },
        {
          key: "userDisplayName",
          filterKey: "userDisplayName",
          label: this.$t("story.userDisplayName"),
          thStyle: "min-width: 250px",
          //   tdClass: "table-col-dinamic-width-numeric",
        },
      ],
      tableFilters: {
        cargoId: 0,
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },

  created() {
    console.log(`Created CargoStory - this.cargoId: ${this.cargoId}`);
    this.tableFilters.cargoId = this.cargoId;
    this.refresh();
  },
  mounted() {},
  computed: {},
  methods: {
    myProvider(ctx, callback) {
      if (this.validateParams(ctx) == false) {
        console.log("Dados informados invalidos");
        return null;
      }
      this.isBusy = true;

      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        cargoId: ctx.filter.cargoId,
      };
      // console.log(apiParam);
      this.$api
        .post("/v1/cargo/story", apiParam)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    validateParams(ctx) {
      // if (ctx.currentPage > 0) return false;
      // if (ctx.perPage > 0) return false;
      if (ctx.filter.cargoId == 0) return false;
      return true;
    },
    async refresh() {
      this.$refs.table.refresh();
    },
  },
  watch: {
    cargoId() {
      console.log(`CargoStory - this.cargoId: ${this.cargoId}`);
      this.tableFilters.cargoId = this.cargoId;
      this.refresh();
    },
  },
};
</script>
